//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ModalDistributors',
  
  props: {
    show: {
      type: Boolean,
      default: false
    },
    productCode: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      searchCep: '',
      proximity: 10,
      selectedState: '',
      distributors: [],
      loading: false,
      searchPerformed: false,
      // Mapa para rastrear imagens com erro e evitar tentar carregá-las novamente
      imageError: {}
    }
  },

  watch: {
    show(newVal) {
      if (newVal) {
        console.log('ModalDistributors opened with productCode:', this.productCode)
        this.resetForm()
        this.loadDistributors()
      }
    },
    
    productCode(newVal) {
      console.log('ProductCode changed to:', newVal)
    }
  },

  methods: {
    // Corrige problemas comuns de codificação (mojibake) vindos da API e limpa caracteres inválidos
    sanitizeText(str) {
      try {
        if (!str) return ''
        let s = String(str)
        // Tenta reparar casos típicos de Latin-1/Windows-1252 interpretados como UTF-8 (ex.: "Mat. ElÃ©tricos")
        if (/[ - A0ÃÂ]/.test(s) || /�/.test(s)) {
          try {
            // Converte bytes Latin-1 para UTF-8 corretamente
            s = decodeURIComponent(escape(s))
          } catch (e) {
            // Fallback: usa TextDecoder com latin1->utf8
            try {
              const bytes = new Uint8Array(s.length)
              for (let i = 0; i < s.length; i++) bytes[i] = s.charCodeAt(i) & 0xFF
              s = new TextDecoder('utf-8').decode(bytes)
            } catch (_) {}
          }
        }
        // Correções específicas ANTES de remover o caractere de substituição
        s = s.replace(/\bEl�tricos\b/g, 'Elétricos')
        s = s.replace(/\bel�tricos\b/g, 'elétricos')
        s = s.replace(/\bEL�TRICOS\b/g, 'ELÉTRICOS')
        s = s.replace(/\bEl�trico\b/g, 'Elétrico')
        s = s.replace(/\bel�trico\b/g, 'elétrico')
        s = s.replace(/\bEL�TRICO\b/g, 'ELÉTRICO')
        // Remove caracteres de substituição restantes (�) que indicam bytes ilegais perdidos
        s = s.replace(/\uFFFD/g, '')
        // Normaliza espaços duplicados
        s = s.replace(/\s{2,}/g, ' ').trim()
        // Correções específicas de termos comuns sem acento vindos da API
        // Pedido: garantir 'é' em 'Eletricos'
        s = s.replace(/\beletricos\b/g, 'elétricos')
        s = s.replace(/\bEletricos\b/g, 'Elétricos')
        s = s.replace(/\bELETRICOS\b/g, 'ELÉTRICOS')
        // Também corrigir quando o caractere foi removido: 'Eltricos'/'Eltrico'
        s = s.replace(/\beltricos\b/g, 'elétricos')
        s = s.replace(/\bEltricos\b/g, 'Elétricos')
        s = s.replace(/\bELTRICOS\b/g, 'ELÉTRICOS')
        s = s.replace(/\beltrico\b/g, 'elétrico')
        s = s.replace(/\bEltrico\b/g, 'Elétrico')
        s = s.replace(/\bELTRICO\b/g, 'ELÉTRICO')
        // Correções para 'Comércio' com caractere de substituição
        s = s.replace(/\bCom�rcio\b/g, 'Comércio')
        s = s.replace(/\bcom�rcio\b/g, 'comércio')
        s = s.replace(/\bCOM�RCIO\b/g, 'COMÉRCIO')
        // Correções para 'Comércio' quando o caractere foi removido: 'Comrcio'
        s = s.replace(/\bcomrcio\b/g, 'comércio')
        s = s.replace(/\bComrcio\b/g, 'Comércio')
        s = s.replace(/\bCOMRCIO\b/g, 'COMÉRCIO')
        // Correções para 'Comércio' sem acento: 'Comercio'
        s = s.replace(/\bcomercio\b/g, 'comércio')
        s = s.replace(/\bComercio\b/g, 'Comércio')
        s = s.replace(/\bCOMERCIO\b/g, 'COMÉRCIO')
        // Correções para 'Elétrica' com caractere de substituição
        s = s.replace(/\bEl�trica\b/g, 'Elétrica')
        s = s.replace(/\bel�trica\b/g, 'elétrica')
        s = s.replace(/\bEL�TRICA\b/g, 'ELÉTRICA')
        // Correções para 'Elétrica' quando o caractere foi removido: 'Eltrica'
        s = s.replace(/\beltrica\b/g, 'elétrica')
        s = s.replace(/\bEltrica\b/g, 'Elétrica')
        s = s.replace(/\bELTRICA\b/g, 'ELÉTRICA')
        // Correções para 'Elétrica' sem acento: 'Eletrica'
        s = s.replace(/\beletrica\b/g, 'elétrica')
        s = s.replace(/\bEletrica\b/g, 'Elétrica')
        s = s.replace(/\bELETRICA\b/g, 'ELÉTRICA')
        // Correções para 'Incêndio' com caractere de substituição
        s = s.replace(/\bInc�ndio\b/g, 'Incêndio')
        s = s.replace(/\binc�ndio\b/g, 'incêndio')
        s = s.replace(/\bINC�NDIO\b/g, 'INCÊNDIO')
        // Correções para 'Incêndio' quando o caractere foi removido: 'Incndio'
        s = s.replace(/\bincndio\b/g, 'incêndio')
        s = s.replace(/\bIncndio\b/g, 'Incêndio')
        s = s.replace(/\bINCNDIO\b/g, 'INCÊNDIO')
        // Correções para 'Incêndio' sem acento: 'Incendio'
        s = s.replace(/\bincendio\b/g, 'incêndio')
        s = s.replace(/\bIncendio\b/g, 'Incêndio')
        s = s.replace(/\bINCENDIO\b/g, 'INCÊNDIO')
        return s
      } catch (e) {
        return String(str || '').trim()
      }
    },

    // Converte URL relativa em URL absoluta adicionando https:// se necessário
    getAbsoluteUrl(url) {
      if (!url) return '#'
      // Se já começa com http:// ou https://, retorna como está
      if (/^https?:\/\//i.test(url)) {
        return url
      }
      // Adiciona https:// por padrão
      return 'https://' + url
    },

    // Obtém o nome do distribuidor com sanitização
    getDistributorDisplayName(distributor) {
      const raw = (distributor && (distributor.nome_fantasia || distributor.nome)) || 'Empresa Fulano de Tal'
      return this.sanitizeText(raw)
    },

    // Constrói link do WhatsApp no formato https://wa.me/<DDI><numero_sem_mascara>
    getWhatsappLink(rawNumber) {
      try {
        if (!rawNumber) return null
        // Remove tudo que não é dígito
        let digits = String(rawNumber).replace(/\D/g, '')
        // Remove zeros à esquerda comuns em discagem
        digits = digits.replace(/^0+/, '')
        // Garante prefixo do Brasil (55) apenas se já não existir
        if (!digits.startsWith('55')) {
          digits = '55' + digits
        }
        // Se após normalização não houver dígitos suficientes, evita gerar link inválido
        if (digits.length < 10) {
          return null
        }
        return `https://wa.me/${digits}`
      } catch (e) {
        return null
      }
    },
    closeModal() {
      this.$emit('close')
    },

    resetForm() {
      this.searchCep = ''
      this.proximity = 10
      this.selectedState = ''
      this.distributors = []
      this.searchPerformed = false
    },

    onCepInput() {
      // Remove non-numeric characters and format CEP
      this.searchCep = this.searchCep.replace(/\D/g, '').replace(/(\d{5})(\d{3})/, '$1-$2')
      
      // Se CEP foi digitado, limpar a seleção de estado para garantir exclusividade
      if (this.searchCep.trim() && this.selectedState) {
        console.log('Limpando seleção de estado devido ao preenchimento do CEP')
        this.selectedState = ''
      }
    },

    // Formata o endereço do distribuidor, corrigindo problemas de codificação
    // sem remover letras acentuadas. Usa uma sanitização mais segura.
    formatAddress(distributor) {
      if (!distributor) return 'Endereço não informado'
      
      const parts = []
      // Sanitiza cada campo com uma função mais conservadora
      if (distributor.endereco) parts.push(this.normalizeAddressText(distributor.endereco))
      if (distributor.complemento) parts.push(this.normalizeAddressText(distributor.complemento))
      if (distributor.bairro) parts.push(this.normalizeAddressText(distributor.bairro))
      if (distributor.cidade) parts.push(this.normalizeAddressText(distributor.cidade))
      if (distributor.estado) parts.push(this.normalizeAddressText(distributor.estado))
      if (distributor.cep) {
        const formattedCep = String(distributor.cep).replace(/(\d{5})(\d{3})/, '$1-$2')
        parts.push(this.normalizeAddressText(`CEP: ${formattedCep}`))
      }
      
      const formatted = parts.length > 0 ? parts.join(' – ') : 'Rua dos bobos Nº 0 – Vila Madalena – SP'
      // Normaliza novamente para garantir padronização final
      return this.normalizeAddressText(formatted)
    },

    // Normaliza texto de endereço de forma conservadora, corrigindo mojibake
    // apenas quando detectado e sem remover caracteres acentuados.
    normalizeAddressText(str) {
      try {
        if (!str) return ''
        let s = String(str)

        // Tenta correção Latin-1 -> UTF-8 somente quando padrões de mojibake são detectados
        const looksLikeLatin1Utf8 = /(Ã.|Â.|â.)/.test(s)
        if (looksLikeLatin1Utf8) {
          try {
            s = decodeURIComponent(escape(s))
          } catch (_) {
            // Mantém original se falhar
          }
        }

        // Corrige pontuações comuns quebradas
        s = s
          .replace(/â€“/g, '–')
          .replace(/â€”/g, '—')
          .replace(/â€˜/g, '‘')
          .replace(/â€™/g, '’')
          .replace(/â€œ/g, '“')
          .replace(/â€/g, '”')
          .replace(/â€¦/g, '…')
          .replace(/â€¢/g, '•')
          .replace(/Â /g, ' ')
          .replace(/Â/g, '')

        // Correções pontuais bastante comuns em endereços brasileiros
        s = s.replace(/\bJos�\b/g, 'José')
        s = s.replace(/\bMendon�a\b/g, 'Mendonça')
        s = s.replace(/\bS�o\b/g, 'São')
        s = s.replace(/\bS�O\b/g, 'SÃO')

        // Versões explícitas usando o caractere de substituição U+FFFD
        // Isso ajuda quando o regex com o literal "�" não casa corretamente
        s = s.replace(/Jos\uFFFD/g, 'José')
        s = s.replace(/Mendon\uFFFDa/g, 'Mendonça')
        s = s.replace(/S\uFFFDo/g, 'São')
        s = s.replace(/S\uFFFDO/g, 'SÃO')
        s = s.replace(/S\uFFFDo Paulo/g, 'São Paulo')

        // Fallbacks sem acento para casos comuns
        s = s.replace(/\bJose\b/g, 'José')
        s = s.replace(/\bSao\b/g, 'São')

        // Casos adicionais solicitados
        // Santa Ifigênia
        s = s.replace(/\bSanta Ifig�nia\b/g, 'Santa Ifigênia')
        s = s.replace(/Santa Ifig\uFFFDnia/g, 'Santa Ifigênia')
        // Rua Colonizador Ênio Pipino
        s = s.replace(/\bRua Colonizador �nio Pipino\b/g, 'Rua Colonizador Ênio Pipino')
        s = s.replace(/\bColonizador �nio Pipino\b/g, 'Colonizador Ênio Pipino')
        s = s.replace(/Rua Colonizador \uFFFDnio Pipino/g, 'Rua Colonizador Ênio Pipino')
        s = s.replace(/Colonizador \uFFFDnio Pipino/g, 'Colonizador Ênio Pipino')
        // Prédio Vernier
        s = s.replace(/\bPr�dio Vernier\b/g, 'Prédio Vernier')
        s = s.replace(/Pr\uFFFDo Vernier/g, 'Prédio Vernier')
        // Jardim Independência
        s = s.replace(/\bJardim Independ�ncia\b/g, 'Jardim Independência')
        s = s.replace(/Jardim Independ\uFFFDncia/g, 'Jardim Independência')
        // Nova Divinéia
        s = s.replace(/\bNova Divin�ia\b/g, 'Nova Divinéia')
        s = s.replace(/\bDivin�ia\b/g, 'Divinéia')
        s = s.replace(/Nova Divin\uFFFDia\b/g, 'Nova Divinéia')
        s = s.replace(/Divin\uFFFDia\b/g, 'Divinéia')
        s = s.replace(/\bNova Divineia\b/g, 'Nova Divinéia')
        s = s.replace(/\bDivineia\b/g, 'Divinéia')

        // Restauração dinâmica baseada em vocabulário
        s = this.restoreAccentsDynamically(s)

        // Normaliza espaços
        s = s.replace(/\s{2,}/g, ' ').trim()
        return s
      } catch (e) {
        return String(str || '').trim()
      }
    },
    
    // Remove diacríticos e caracteres de substituição para comparar tokens
    removeDiacritics(text) {
      try {
        return String(text)
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/\uFFFD/g, '')
      } catch (_) {
        return String(text)
      }
    },

    // Restaura acentuação dinamicamente usando um vocabulário básico
    restoreAccentsDynamically(text) {
      if (!text) return ''
      const vocab = {
        jose: 'José',
        mendonca: 'Mendonça',
        sao: 'São',
        ifigenia: 'Ifigênia',
        enio: 'Ênio',
        predio: 'Prédio',
        independencia: 'Independência',
        divineia: 'Divinéia',
        praca: 'Praça',
        vernier: 'Vernier'
      }
      return String(text).replace(/\b([\w\uFFFD]+)\b/g, (match) => {
        const hasReplacementChar = /\uFFFD/.test(match) || /�/.test(match)
        const base = this.removeDiacritics(match.toLowerCase())
        if (hasReplacementChar || vocab[base]) {
          const replacement = vocab[base]
          if (replacement) return replacement
        }
        return match
      })
    },

    async loadDistributors() {
      console.log('loadDistributors called with productCode:', this.productCode)
      console.log('productCode type:', typeof this.productCode)
      console.log('productCode === 0:', this.productCode === 0)
      console.log('productCode === "0":', this.productCode === "0")
      console.log('productCode empty check (!this.productCode):', !this.productCode)
      
      // Mudança: aceitar 0 como um código válido
      if (!this.productCode && this.productCode !== 0 && this.productCode !== "0") {
        console.warn('ProductCode is empty, cannot load distributors')
        return
      }

      this.loading = true
      try {
        console.log('Making API call with productCode:', this.productCode)
        const response = await this.$api.products.getDistributors(this.productCode)
        console.log('API Response:', response)
        
        // Processar a resposta considerando a estrutura aninhada
        let distributors = []
        if (response.data && Array.isArray(response.data)) {
          distributors = response.data.map(item => {
            // Se tem distribuidor aninhado, usar ele, senão usar o item diretamente
            return item.distribuidor || item
          }).filter(distributor => {
            // Filtrar apenas distribuidores com status == true
            return distributor.status === true || distributor.status === 'true' || distributor.status === 1
          })
        }
        
        // Aplicar regra do distribuidor 291
        distributors = this.applyDistributor291Rule(distributors)
        
        this.distributors = distributors
        this.searchPerformed = true
        console.log('Distributors processed:', this.distributors.length, this.distributors)
      } catch (error) {
        console.error('Erro ao carregar distribuidores:', error)
        this.distributors = []
        this.searchPerformed = true
      } finally {
      this.loading = false
    }
  },

    /**
     * Aplica a regra de negócio para o distribuidor de código 291:
     * - Se houver mais de 1 distribuidor: remove o distribuidor 291
     * - Se houver 1 ou menos distribuidores: mostra apenas o distribuidor 291
     * - Nunca deixa a lista vazia (cria distribuidor 291 padrão se necessário)
     */
    applyDistributor291Rule(distributors) {
      if (!Array.isArray(distributors)) {
        return []
      }

      console.log('=== APLICANDO REGRA DO DISTRIBUIDOR 291 ===')
      console.log('Distribuidores antes da regra:', distributors.length)
      
      // Encontrar o distribuidor 291
      const dist291 = distributors.find(d => 
        String(d.codigo) === '291' || 
        String(d.id) === '291' || 
        parseInt(d.codigo) === 291 || 
        parseInt(d.id) === 291
      )
      
      console.log('Distribuidor 291 encontrado:', dist291 ? 'SIM' : 'NÃO')
      
      // Se houver mais de 1 distribuidor
      if (distributors.length > 1) {
        console.log('Quantidade > 1: Removendo distribuidor 291 da lista')
        const filtered = distributors.filter(d => 
          String(d.codigo) !== '291' && 
          String(d.id) !== '291' && 
          parseInt(d.codigo) !== 291 && 
          parseInt(d.id) !== 291
        )
        console.log('Distribuidores após remoção do 291:', filtered.length)
        return filtered
      }
      
      // Se houver 1 ou menos distribuidores
      if (distributors.length <= 1) {
        console.log('Quantidade <= 1: Mostrando apenas distribuidor 291')
        
        // Se o distribuidor 291 existe, retornar apenas ele
        if (dist291) {
          console.log('Retornando apenas o distribuidor 291')
          return [dist291]
        }
        
        // Se não existe o distribuidor 291, criar um objeto padrão
        console.log('Distribuidor 291 não encontrado, criando distribuidor 291 padrão')
        const defaultDist291 = {
          id: 291,
          codigo: 291,
          nome_fantasia: 'Departamento Comercial - GRUPO INTELLI',
          razao_social: 'INTELLI',
          endereco: 'Avenida Marginal, 680',
          complemento: '',
          bairro: 'Centro',
          cidade: 'Orlandia',
          estado: 'SP',
          cep: '14620049',
          telefone: '1638201562',
          whatsapp: '5516982550052',
          email: 'vendas@grupointelli.com.br',
          site: '',
          ecommerce: '',
          status: true,
          img_base64: '/9j/4Q QRXhpZgAATU0AKgAAAAgABwESAAMAAAABAAEAAAEaAAUAAAABAAAAYgEbAAUAAAABAAAAagEoAAMAAAABAAIAAAExAAIAAAAgAAAAcgEyAAIAAAAUAAAAkodpAAQAAAABAAAAqAAAANQACvyAAAAnEAAK/IAAACcQQWRvYmUgUGhvdG9zaG9wIDI2LjExIChXaW5kb3dzKQAyMDI1OjExOjEzIDA3OjU4OjQzAAAAAAOgAQADAAAAAf//AACgAgAEAAAAAQAAAMigAwAEAAAAAQAAAJYAAAAAAAAABgEDAAMAAAABAAYAAAEaAAUAAAABAAABIgEbAAUAAAABAAABKgEoAAMAAAABAAIAAAIBAAQAAAABAAABMgICAAQAAAABAAAOVgAAAAAAAABIAAAAAQAAAEgAAAAB/9j/7QAMQWRvYmVfQ00AAf/uAA5BZG9iZQBkgAAAAAH/2wCEAAwICAgJCAwJCQwRCwoLERUPDAwPFRgTExUTExgRDAwMDAwMEQwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwBDQsLDQ4NEA4OEBQODg4UFA4ODg4UEQwMDAwMEREMDAwMDAwRDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDP/AABEIAHgAoAMBIgACEQEDEQH/3QAEAAr/xAE/AAABBQEBAQEBAQAAAAAAAAADAAECBAUGBwgJCgsBAAEFAQEBAQEBAAAAAAAAAAEAAgMEBQYHCAkKCxAAAQQBAwIEAgUHBggFAwwzAQACEQMEIRIxBUFRYRMicYEyBhSRobFCIyQVUsFiMzRygtFDByWSU/Dh8WNzNRaisoMmRJNUZEXCo3Q2F9JV4mXys4TD03Xj80YnlKSFtJXE1OT0pbXF1eX1VmZ2hpamtsbW5vY3R1dnd4eXp7fH1 f3EQACAgECBAQDBAUGBwcGBTUBAAIRAyExEgRBUWFxIhMFMoGRFKGxQiPBUtHwMyRi4XKCkkNTFWNzNPElBhaisoMHJjXC0kSTVKMXZEVVNnRl4vKzhMPTdePzRpSkhbSVxNTk9KW1xdXl9VZmdoaWprbG1ub2JzdHV2d3h5ent8f/2gAMAwEAAhEDEQA/APVUkkklKSSSSUpJJJJSkkkklKSSSSUpJJJJSkkkklKSSSSUpJJJJSkkkklP/9D1VJJJJSkkkklKSSSSUpJJJJSkkkklKSSSSUpJJJJSkkkklKSSSSUpJJJJT//R9VTEganQJ1i9V6nVVVZdc4txqtIbq57iYYxjfz3v/wAH/wBuJKdJ2ditMb5 AJ/Ip1ZFFpit4J8OD9xXCW/WLqD3TS2qhnZm31Hf27H/AEv7DFa6f9YDZaynOa2tzyBXk1 1ocfoNurO709zv8Mz/riSntklVwsl1rTXZ/O18z3HCtJKUkkkkpSSSSSlJJJJKUksz6y9cq r/Q8vq9tZuGM0bagY3Pe5tNTd35rfUsZvd 4uN6Z9Zvrg3qHT7Os9S6TjU9R9K09Nfvbcyi522s0hrf56z6LG2ZFvp/4b/CpKfRUl5bmfXf62DN62 jqHS8fH6RlX1sxcs7L7WUus2V0Vj ee9lfp/Tr32ra6R9cer9R s/RsNzGUYfUumDNuoLPcLD6zZZY47vTd6LLKv Bekp7hJeYdT v/ANY8ar6zOrfSD0jPpx8Wa5it9mVW5r9ff7cev3q5g/XnrnTeq5XT t24PVKqMGzPN/TnEhnphzm49rnDZvt2Nb9D/tRR  kp9DSXmr/rP/jFxukV/W/Irwn9Hfssf01si0UPcGMs9Xa73WNdu3 tbs3 p9n/AJypehYGbVn4GNn0Bwpy6mX1h4hwbY0Ws3gbvdtckp//0vUrSRU8jkNJH3LifrK50Ydf5n6R/wDbGyv/AKLHLuCARB4K5vrfSjk1HHDgy2p3qY1jvozG1zLP DtZ7Hu/fSU8tiY1mZlVYlRaLLiWsLpDQQHP923d 4td31K6u5pabcaCCD7n9/8ArSq9Hx8jH6/g15NL6X odHDQ/o7Po2Nmt7f6rlzv1w6r1Wj6xdSrpzcmqtlsNYy6xrQNjPosa/a1MnPgF1bY5XljzEjESEaHFq p9Pwsuj0XZDmOsbWGXFpMFwADnNkN/OatBeZ/4zOo9Qxev49eLlX49ZxGuLKrXsaT6lw3ba3N9y1f8Xf1rfn1Ho/ULS/LpBdjWvJLra/zq3Od9O6j/p0/8VYgMg4 FfLkpjAM4IlEizEfNGL26S8r/wAYvUupYv1ksrxszIor9Ct2yu17Gyd uxj2tV/60f8AOG/of1bs6X9tte7E3ZL8U2kkmvFLHXupPuc79Jt9T/hEvdHqFH0pHIkjETOIGba/0fTx6voqS8Mys76zYVgqzcnPxbC3eGXW3McWzG8Ne8e32o7G/Xa gXUDqttVjd1djDkOa4HhzHNd7k33/wCqWY/CyBZzQo9X2xJea/4yc/qGL1LBbjZV OHYsvbXa9gJ3nVzWOb71g49P13yqGZGMepXUWCa7GW2lrhxLf0iJy0SOEmmPH8PM8cchyxgJfvPrfWekYfWul5HS84OOPlN2v2mHAgh9djHa  qxrLGblxuP/i56263p9HUettyen9KsqsxmjGY28ik/oqPtG51rKmbn7N1t7P DVL6n4n1vr seI/qTM8YYFvqG99hr1rfs3ix7mfTWT1vqvVWfWrMoZnZLKhnForbdYGhu9vsawP2tal7tCyDvSh8PMshhHJGVR4 IajeuF6TN/xVY2czrLr8iv7V1HMdmYeUKjvo3PfY iz9J mqe2zZ Z/plc6n9Sut5eX0/rWN1VmJ1/Bo zW5DKQabmy/a/0HHbW/ZbZ6nstr/wBF6Pprslz31 vvx/qpm3Y9j6bWmrbZW4scJtqaYewtd9FSE0CezUxw45xgDXHIR/xnDu/xYWW9BzcJ/UfV6n1TJZl5uc vRxYXuFbKWv8Ab77rXb10lH1P rePhZOFj9PppqzazTkFjYc5rhx6rt1v8tnv9j1y/wDivzs7LyeojKybsgMZTsFtj7AJNs7fUc7bwvQUIS4ha7mMJw5DjJ4jGtR46vn5/wAW3XLMNvQr/rA931dY8OGKKWi4sDvVFBvn838z cq9T3/ZfzF3eNjUYmNVi47BXRjsbVUwcNYwbK2a/utavMP8Y3UupYv1jfXjZeRRX9nrdsrtexsnfrsre1q9G6G57 idPe9xe92LSXPcS5xJrZLnOd7nOchGdyMa2X5eWOPFjymQIy7Ds//T9VQ7qK7m7bBMcHuPgiJJKadWC6q1rm2ksaZ2EeXkf  rx766/wDim6p/x3/fK17avEvrt/4puqf8b/3ytQ5/lHm6Pwn en/c/a7P NT/AMUWN/4Sb/59vXO243UejXYOdW/Y6 tmXh5DAY15Z7xt9Sl36O r/wBF2rov8an/AIosb/wk3/z7eujo r1PX/qF0/FMMya8dtmJcZ9lgH523/BW/wA3b/5NjEww4pzrcahtQzjDy3LmQuE/RPyLwX1r6zT1vPr6hX7X2YtbciuCNlrd4trbP02fn1v/AHF679XP/E90v/wnj/8Anpi8NyaLsey3HyGGu6kuZZWeWubo5q9y rn/AInul/8AhPH/APPTEcJJlIlj JxjHBhjH5QfT5U d/41P/FHj/8AhJn/AJ9vXffVH/xMdM/8LV/kXA/41P8AxR4//hJn/n29d99Uf/Ex0z/wtX ROh/OzYua/wBw8v5/seH/AMa3/LGF/wCFj/1ZWT036/dd6Xg09PxTjijHG1m9hLoku9x3t/eWt/jW/wCWML/wsf8Aqyo9D/xgYnS kYvT7OmnIfjM2m3ewTq53BZ/KTD/ADkvVwtrFG Tw/qRn/qkiPD83q9TsfUX649X691a/EznUmqvHNrRWza7cH1s53u9u164zrv/AIsMz/w//wB/au56B/jAxeq9Xx nVdOOO/J3D1d7TAY11v0Wsb 4uD sVnpfWrqFpG4V5rn7Zidrg6J SUz6B6uLXdHLQI5jJ q9nixioAiXXf0vt65v/GJ/4kM740/ fqlg/wDjtN/8qnf9vj/0ij9d sH/ADg/xe9Qz/s5xouZV6Zfv jbR7t22v8AeUpyRlGQB6Fo4uUz4s2KWSHDH3IC7if0v6rS/wAU39K6n/Up/LcvSF4z9UvrU36t25VhxTlHKbW0AWCvbsLz3ZZu3eouox/8aovyKqB0st9Wxlc uNNzgyf5n UmYskREAnVn57k8 TPOcIXA1rcekf7zg/4zf8AxTP/APC1f/oxem9A/wCQunf FaP/AD2xeZf4zf8AxTP/APC1f/oxem9A/wCQunf FaP/AD2xHH/OTW85/uPlvL/uX//U9VSSSSUpc/n/AFF rfUMu7Mysd778h26xwtsaCYDfotft/NXQJIEA7i10Mk4G4SMT/VNOP1j6p9D61lNy o0usuZWKmubY9ntBc Ntbmt lY5aGDhY/T8OrCxWllFDQytpJcQB/KfLlYSSoXdKOSZiImRMY7RJ9IcTqv1N r3V8t2bm4xdkPaGvex72bg0bW7xW5rXO2 3ctbFxqcTGpxaBtpx2NqraSTDWAMYNzvc72tRUkgADYG6pZJyiIykTGPygnSLjdY qXQ tZTcvqNLrbmViprm2PZ7QXPjbW5rfpWOWlg4WPgYlWHjNLaKGhlbSS4ho49zpcjpJULutVHJMxETImMdok kOR1n6q9E63kMyOo0uttqZ6bC2x7AGzv jW5rfpOVD/AMbn6p/9xbP 3rf/AEoumSQMInUgL48xmiBGOSQA2AkXB6d9Sfq70zNqz8Oh7MimfTcbbHAbmmt3te9zfouUMv6h/VnMyrsvIx3uuyHmyxwtsEucZd7Wv2roUkuCO1BX3jNfF7kuKqviN08z/wCNz9U/ 4tn/b1v/pRXq/qn0Ovo9vRW0uGBe/1LK/UeSXSx/wDObvU lUxbCSXBEdAo8xmlV5JGjYuR3DzP/jc/VP8A7i2f9vW/ lFKv/F59VarGWsxnh9bg9p9a3lp3N/wi6RJLgj 6PsT95z/AOdn/jFxOrfU7oHWMs5mfQ6y9zQwuFj2ja36PtY9re61sbHqxcarFpG2qhja6wSSQ1g2MG53ud7WoqSIABut2OWScoiJkTGPygnSL//V9VSSSSUpJJJJSkkkklKSSSSUpJJJJSkkkklKSSSSUpJJJJSkkkklKSSSSU//1vVUl8qpJKfqpJfKqSSn6qSXyqkkp qkl8qpJKfqpJfKqSSn6qSXyqkkp qkl8qpJKfqpJfKqSSn6qSXyqkkp qkl8qpJKf/2f/tGLhQaG90b3Nob3AgMy4wADhCSU0EBAAAAAAADxwBWgADGyVHHAIAAAIAAAA4QklNBCUAAAAAABDNz/p9qMe CQVwdq6vBcNOOEJJTQQ6AAAAAAEfAAAAEAAAAAEAAAAAAAtwcmludE91dHB1dAAAAAUAAAAAUHN0U2Jvb2wBAAAAAEludGVlbnVtAAAAAEludGUAAAAASW1nIAAAAA9wcmludFNpeHRlZW5CaXRib29sAAAAAAtwcmludGVyTmFtZVRFWFQAAAAUAEUAUABTAE8ATgAgAEwAMQA0ADEANQAwACAAUwBlAHIAaQBlAHMAAAAAAA9wcmludFByb29mU2V0dXBPYmpjAAAAFgBDAG8AbgBmAGkAZwB1AHIAYQDnAOMAbwAgAGQAZQAgAFAAcgBvAHYAYQAAAAAACnByb29mU2V0dXAAAAABAAAAAEJsdG5lbnVtAAAADGJ1aWx0aW5Qcm9vZgAAAAlwcm9vZkNNWUsAOEJJTQQ7AAAAAAItAAAAEAAAAAEAAAAAABJwcmludE91dHB1dE9wdGlvbnMAAAAXAAAAAENwdG5ib29sAAAAAABDbGJyYm9vbAAAAAAAUmdzTWJvb2wAAAAAAENybkNib29sAAAAAABDbnRDYm9vbAAAAAAATGJsc2Jvb2wAAAAAAE5ndHZib29sAAAAAABFbWxEYm9vbAAAAAAASW50cmJvb2wAAAAAAEJja2dPYmpjAAAAAQAAAAAAAFJHQkMAAAADAAAAAFJkICBkb3ViQG/gAAAAAAAAAAAAR3JuIGRvdWJAb AAAAAAAAAAAABCbCAgZG91YkBv4AAAAAAAAAAAAEJyZFRVbnRGI1JsdAAAAAAAAAAAAAAAAEJsZCBVbnRGI1JsdAAAAAAAAAAAAAAAAFJzbHRVbnRGI1B4bEBSAAAAAAAAAAAACnZlY3RvckRhdGFib29sAQAAAABQZ1BzZW51bQAAAABQZ1BzAAAAAFBnUEMAAAAATGVmdFVudEYjUmx0AAAAAAAAAAAAAAAAVG9wIFVudEYjUmx0AAAAAAAAAAAAAAAAU2NsIFVudEYjUHJjQFkAAAAAAAAAAAAQY3JvcFdoZW5QcmludGluZ2Jvb2wAAAAADmNyb3BSZWN0Qm90dG9tbG9uZwAAAAAAAAAMY3JvcFJlY3RMZWZ0bG9uZwAAAAAAAAANY3JvcFJlY3RSaWdodGxvbmcAAAAAAAAAC2Nyb3BSZWN0VG9wbG9uZwAAAAAAOEJJTQPtAAAAAAAQAEgAAAABAAIASAAAAAEAAjhCSU0EJgAAAAAADgAAAAAAAAAAAAA/gAAAOEJJTQPyAAAAAAAKAAD///////8AADhCSU0EDQAAAAAABAAAAFo4QklNBBkAAAAAAAQAAAAeOEJJTQPzAAAAAAAJAAAAAAAAAAABADhCSU0nEAAAAAAACgABAAAAAAAAAAI4QklNA/UAAAAAAEgAL2ZmAAEAbGZmAAYAAAAAAAEAL2ZmAAEAoZmaAAYAAAAAAAEAMgAAAAEAWgAAAAYAAAAAAAEANQAAAAEALQAAAAYAAAAAAAE4QklNA/gAAAAAAHAAAP////////////////////////////8D6AAAAAD/////////////////////////////A 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 f3EQACAgECBAQDBAUGBwcGBTUBAAIRAyExEgRBUWFxIhMFMoGRFKGxQiPBUtHwMyRi4XKCkkNTFWNzNPElBhaisoMHJjXC0kSTVKMXZEVVNnRl4vKzhMPTdePzRpSkhbSVxNTk9KW1xdXl9VZmdoaWprbG1ub2JzdHV2d3h5ent8f/2gAMAwEAAhEDEQA/APVUkkklKSSSSUpJJJJSkkkklKSSSSUpJJJJSkkkklKSSSSUpJJJJSkkkklP/9D1VJJJJSkkkklKSSSSUpJJJJSkkkklKSSSSUpJJJJSkkkklKSSSSUpJJJJT//R9VTEganQJ1i9V6nVVVZdc4txqtIbq57iYYxjfz3v/wAH/wBuJKdJ2ditMb5 AJ/Ip1ZFFpit4J8OD9xXCW/WLqD3TS2qhnZm31Hf27H/AEv7DFa6f9YDZaynOa2tzyBXk1 1ocfoNurO709zv8Mz/riSntklVwsl1rTXZ/O18z3HCtJKUkkkkpSSSSSlJJJJKUksz6y9cq r/Q8vq9tZuGM0bagY3Pe5tNTd35rfUsZvd 4uN6Z9Zvrg3qHT7Os9S6TjU9R9K09Nfvbcyi522s0hrf56z6LG2ZFvp/4b/CpKfRUl5bmfXf62DN62 jqHS8fH6RlX1sxcs7L7WUus2V0Vj ee9lfp/Tr32ra6R9cer9R s/RsNzGUYfUumDNuoLPcLD6zZZY47vTd6LLKv Bekp7hJeYdT v/ANY8ar6zOrfSD0jPpx8Wa5it9mVW5r9ff7cev3q5g/XnrnTeq5XT t24PVKqMGzPN/TnEhnphzm49rnDZvt2Nb9D/tRR  kp9DSXmr/rP/jFxukV/W/Irwn9Hfssf01si0UPcGMs9Xa73WNdu3 tbs3 p9n/AJypehYGbVn4GNn0Bwpy6mX1h4hwbY0Ws3gbvdtckp//0vUrSRU8jkNJH3LifrK50Ydf5n6R/wDbGyv/AKLHLuCARB4K5vrfSjk1HHDgy2p3qY1jvozG1zLP DtZ7Hu/fSU8tiY1mZlVYlRaLLiWsLpDQQHP923d 4td31K6u5pabcaCCD7n9/8ArSq9Hx8jH6/g15NL6X odHDQ/o7Po2Nmt7f6rlzv1w6r1Wj6xdSrpzcmqtlsNYy6xrQNjPosa/a1MnPgF1bY5XljzEjESEaHFq p9Pwsuj0XZDmOsbWGXFpMFwADnNkN/OatBeZ/4zOo9Qxev49eLlX49ZxGuLKrXsaT6lw3ba3N9y1f8Xf1rfn1Ho/ULS/LpBdjWvJLra/zq3Od9O6j/p0/8VYgMg4 FfLkpjAM4IlEizEfNGL26S8r/wAYvUupYv1ksrxszIor9Ct2yu17Gyd uxj2tV/60f8AOG/of1bs6X9tte7E3ZL8U2kkmvFLHXupPuc79Jt9T/hEvdHqFH0pHIkjETOIGba/0fTx6voqS8Mys76zYVgqzcnPxbC3eGXW3McWzG8Ne8e32o7G/Xa gXUDqttVjd1djDkOa4HhzHNd7k33/wCqWY/CyBZzQo9X2xJea/4yc/qGL1LBbjZV OHYsvbXa9gJ3nVzWOb71g49P13yqGZGMepXUWCa7GW2lrhxLf0iJy0SOEmmPH8PM8cchyxgJfvPrfWekYfWul5HS84OOPlN2v2mHAgh9djHa  qxrLGblxuP/i56263p9HUettyen9KsqsxmjGY28ik/oqPtG51rKmbn7N1t7P DVL6n4n1vr seI/qTM8YYFvqG99hr1rfs3ix7mfTWT1vqvVWfWrMoZnZLKhnForbdYGhu9vsawP2tal7tCyDvSh8PMshhHJGVR4 IajeuF6TN/xVY2czrLr8iv7V1HMdmYeUKjvo3PfY iz9J mqe2zZ Z/plc6n9Sut5eX0/rWN1VmJ1/Bo zW5DKQabmy/a/0HHbW/ZbZ6nstr/wBF6Pprslz31 vvx/qpm3Y9j6bWmrbZW4scJtqaYewtd9FSE0CezUxw45xgDXHIR/xnDu/xYWW9BzcJ/UfV6n1TJZl5uc vRxYXuFbKWv8Ab77rXb10lH1P rePhZOFj9PppqzazTkFjYc5rhx6rt1v8tnv9j1y/wDivzs7LyeojKybsgMZTsFtj7AJNs7fUc7bwvQUIS4ha7mMJw5DjJ4jGtR46vn5/wAW3XLMNvQr/rA931dY8OGKKWi4sDvVFBvn838z cq9T3/ZfzF3eNjUYmNVi47BXRjsbVUwcNYwbK2a/utavMP8Y3UupYv1jfXjZeRRX9nrdsrtexsnfrsre1q9G6G57 idPe9xe92LSXPcS5xJrZLnOd7nOchGdyMa2X5eWOPFjymQIy7Ds//T9VQ7qK7m7bBMcHuPgiJJKadWC6q1rm2ksaZ2EeXkf  rx766/wDim6p/x3/fK17avEvrt/4puqf8b/3ytQ5/lHm6Pwn en/c/a7P NT/AMUWN/4Sb/59vXO243UejXYOdW/Y6 tmXh5DAY15Z7xt9Sl36O r/wBF2rov8an/AIosb/wk3/z7eujo r1PX/qF0/FMMya8dtmJcZ9lgH523/BW/wA3b/5NjEww4pzrcahtQzjDy3LmQuE/RPyLwX1r6zT1vPr6hX7X2YtbciuCNlrd4trbP02fn1v/AHF679XP/E90v/wnj/8Anpi8NyaLsey3HyGGu6kuZZWeWubo5q9y rn/AInul/8AhPH/APPTEcJJlIlj JxjHBhjH5QfT5U d/41P/FHj/8AhJn/AJ9vXffVH/xMdM/8LV/kXA/41P8AxR4//hJn/n29d99Uf/Ex0z/wtX ROh/OzYua/wBw8v5/seH/AMa3/LGF/wCFj/1ZWT036/dd6Xg09PxTjijHG1m9hLoku9x3t/eWt/jW/wCWML/wsf8Aqyo9D/xgYnS kYvT7OmnIfjM2m3ewTq53BZ/KTD/ADkvVwtrFG Tw/qRn/qkiPD83q9TsfUX649X691a/EznUmqvHNrRWza7cH1s53u9u164zrv/AIsMz/w//wB/au56B/jAxeq9Xx nVdOOO/J3D1d7TAY11v0Wsb 4uD sVnpfWrqFpG4V5rn7Zidrg6J SUz6B6uLXdHLQI5jJ q9nixioAiXXf0vt65v/GJ/4kM740/ fqlg/wDjtN/8qnf9vj/0ij9d sH/ADg/xe9Qz/s5xouZV6Zfv jbR7t22v8AeUpyRlGQB6Fo4uUz4s2KWSHDH3IC7if0v6rS/wAU39K6n/Up/LcvSF4z9UvrU36t25VhxTlHKbW0AWCvbsLz3ZZu3eouox/8aovyKqB0st9Wxlc uNNzgyf5n UmYskREAnVn57k8 TPOcIXA1rcekf7zg/4zf8AxTP/APC1f/oxem9A/wCQunf FaP/AD2xeZf4zf8AxTP/APC1f/oxem9A/wCQunf FaP/AD2xHH/OTW85/uPlvL/uX//U9VSSSSUpc/n/AFF rfUMu7Mysd778h26xwtsaCYDfotft/NXQJIEA7i10Mk4G4SMT/VNOP1j6p9D61lNy o0usuZWKmubY9ntBc Ntbmt lY5aGDhY/T8OrCxWllFDQytpJcQB/KfLlYSSoXdKOSZiImRMY7RJ9IcTqv1N r3V8t2bm4xdkPaGvex72bg0bW7xW5rXO2 3ctbFxqcTGpxaBtpx2NqraSTDWAMYNzvc72tRUkgADYG6pZJyiIykTGPygnSLjdY qXQ tZTcvqNLrbmViprm2PZ7QXPjbW5rfpWOWlg4WPgYlWHjNLaKGhlbSS4ho49zpcjpJULutVHJMxETImMdok kOR1n6q9E63kMyOo0uttqZ6bC2x7AGzv jW5rfpOVD/AMbn6p/9xbP 3rf/AEoumSQMInUgL48xmiBGOSQA2AkXB6d9Sfq70zNqz8Oh7MimfTcbbHAbmmt3te9zfouUMv6h/VnMyrsvIx3uuyHmyxwtsEucZd7Wv2roUkuCO1BX3jNfF7kuKqviN08z/wCNz9U/ 4tn/b1v/pRXq/qn0Ovo9vRW0uGBe/1LK/UeSXSx/wDObvU lUxbCSXBEdAo8xmlV5JGjYuR3DzP/jc/VP8A7i2f9vW/ lFKv/F59VarGWsxnh9bg9p9a3lp3N/wi6RJLgj 6PsT95z/AOdn/jFxOrfU7oHWMs5mfQ6y9zQwuFj2ja36PtY9re61sbHqxcarFpG2qhja6wSSQ1g2MG53ud7WoqSIABut2OWScoiJkTGPygnSL//V9VSSSSUpJJJJSkkkklKSSSSUpJJJJSkkkklKSSSSUpJJJJSkkkklKSSSSU//1vVUl8qpJKfqpJfKqSSn6qSXyqkkp qkl8qpJKfqpJfKqSSn6qSXyqkkp qkl8qpJKfqpJfKqSSn6qSXyqkkp qkl8qpJKf/2ThCSU0EIQAAAAAAVwAAAAEBAAAADwBBAGQAbwBiAGUAIABQAGgAbwB0AG8AcwBoAG8AcAAAABQAQQBkAG8AYgBlACAAUABoAG8AdABvAHMAaABvAHAAIAAyADAAMgA1AAAAAQA4QklNBAYAAAAAAAcABAEBAAEBAP/hEMBodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8 IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDkuMS1jMDAzIDc5Ljk2OTBhODcsIDIwMjUvMDMvMDYtMTk6MTI6MDMgICAgICAgICI IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIiB4bWxuczpwaG90b3Nob3A9Imh0dHA6Ly9ucy5hZG9iZS5jb20vcGhvdG9zaG9wLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdEV2dD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlRXZlbnQjIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgMjYuMTAgKFdpbmRvd3MpIiB4bXA6Q3JlYXRlRGF0ZT0iMjAyNS0wOS0zMFQxMDoxNDoxNS0wMzowMCIgeG1wOk1vZGlmeURhdGU9IjIwMjUtMTEtMTNUMDc6NTg6NDMtMDM6MDAiIHhtcDpNZXRhZGF0YURhdGU9IjIwMjUtMTEtMTNUMDc6NTg6NDMtMDM6MDAiIGRjOmZvcm1hdD0iaW1hZ2UvanBlZyIgcGhvdG9zaG9wOkNvbG9yTW9kZT0iMyIgcGhvdG9zaG9wOklDQ1Byb2ZpbGU9IkFkb2JlIFJHQiAoMTk5OCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NzhlY2RmZGQtYWNlYS0wNjRjLWFhOTktNTllM2MyNGUwYTAwIiB4bXBNTTpEb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6NjQxN2YxMjQtNjA5Ny0yMjRmLWJhODUtNDQzM2EwZTAzNzViIiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6ZGI4NzYzNTUtZTY3OC0xMDQ5LTg1ZDktYWVlYTA0MTZmM2FkIj4gPHhtcE1NOkhpc3Rvcnk IDxyZGY6U2VxPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iY3JlYXRlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDpkYjg3NjM1NS1lNjc4LTEwNDktODVkOS1hZWVhMDQxNmYzYWQiIHN0RXZ0OndoZW49IjIwMjUtMDktMzBUMTA6MTQ6MTUtMDM6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCAyNi4xMCAoV2luZG93cykiLz4gPHJkZjpsaSBzdEV2dDphY3Rpb249InNhdmVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOmJmYWQ0ZWNlLTM4YTEtN2I0OC04MDQ5LWI5NzYyNmIwYWFkNiIgc3RFdnQ6d2hlbj0iMjAyNS0xMS0xM1QwNzo1ODo0My0wMzowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIDI2LjExIChXaW5kb3dzKSIgc3RFdnQ6Y2hhbmdlZD0iLyIvPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iY29udmVydGVkIiBzdEV2dDpwYXJhbWV0ZXJzPSJmcm9tIGFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5waG90b3Nob3AgdG8gaW1hZ2UvanBlZyIvPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iZGVyaXZlZCIgc3RFdnQ6cGFyYW1ldGVycz0iY29udmVydGVkIGZyb20gYXBwbGljYXRpb24vdm5kLmFkb2JlLnBob3Rvc2hvcCB0byBpbWFnZS9qcGVnIi8 IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJzYXZlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDo3OGVjZGZkZC1hY2VhLTA2NGMtYWE5OS01OWUzYzI0ZTBhMDAiIHN0RXZ0OndoZW49IjIwMjUtMTEtMTNUMDc6NTg6NDMtMDM6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCAyNi4xMSAoV2luZG93cykiIHN0RXZ0OmNoYW5nZWQ9Ii8iLz4gPC9yZGY6U2VxPiA8L3htcE1NOkhpc3Rvcnk IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOmJmYWQ0ZWNlLTM4YTEtN2I0OC04MDQ5LWI5NzYyNmIwYWFkNiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpkYjg3NjM1NS1lNjc4LTEwNDktODVkOS1hZWVhMDQxNmYzYWQiIHN0UmVmOm9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpkYjg3NjM1NS1lNjc4LTEwNDktODVkOS1hZWVhMDQxNmYzYWQiLz4gPC9yZGY6RGVzY3JpcHRpb24 IDwvcmRmOlJERj4gPC94OnhtcG1ldGE ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPD94cGFja2V0IGVuZD0idyI/Pv/iAkBJQ0NfUFJPRklMRQABAQAAAjBBREJFAhAAAG1udHJSR0IgWFlaIAfPAAYAAwAAAAAAAGFjc3BBUFBMAAAAAG5vbmUAAAAAAAAAAAAAAAAAAAAAAAD21gABAAAAANMtQURCRQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACmNwcnQAAAD8AAAAMmRlc2MAAAEwAAAAa3d0cHQAAAGcAAAAFGJrcHQAAAGwAAAAFHJUUkMAAAHEAAAADmdUUkMAAAHUAAAADmJUUkMAAAHkAAAADnJYWVoAAAH0AAAAFGdYWVoAAAIIAAAAFGJYWVoAAAIcAAAAFHRleHQAAAAAQ29weXJpZ2h0IDE5OTkgQWRvYmUgU3lzdGVtcyBJbmNvcnBvcmF0ZWQAAABkZXNjAAAAAAAAABFBZG9iZSBSR0IgKDE5OTgpAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYWVogAAAAAAAA81EAAQAAAAEWzFhZWiAAAAAAAAAAAAAAAAAAAAAAY3VydgAAAAAAAAABAjMAAGN1cnYAAAAAAAAAAQIzAABjdXJ2AAAAAAAAAAECMwAAWFlaIAAAAAAAAJwYAABPpQAABPxYWVogAAAAAAAANI0AAKAsAAAPlVhZWiAAAAAAAAAmMQAAEC8AAL6c/ 4AIUFkb2JlAGQAAAAAAQMAEAMCAwYAAAAAAAAAAAAAAAD/2wCEAAYEBAQFBAYFBQYJBgUGCQsIBgYICwwKCgsKCgwQDAwMDAwMEAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwBBwcHDQwNGBAQGBQODg4UFA4ODg4UEQwMDAwMEREMDAwMDAwRDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDP/CABEIAJYAyAMBEQACEQEDEQH/xADdAAEAAgMBAQEAAAAAAAAAAAAABwgEBQYCAwkBAQACAwEBAAAAAAAAAAAAAAAEBQEDBgIHEAAABQMBBQcEAQUAAAAAAAABAgMEBgAFBwgxMhMzFBAgERI1FzcwcDQ2FkBgISIVEQACAQIDAwQMCQkJAQAAAAABAgMEBQAREiETBhAxIjJBUUJSstJzFHSUdTZhcbFicjOztBUgMKGCwiPDNQdAYHCBkWPTlRYmEgACAQEFBgQEBwEAAAAAAAAAAQIxEBEhEjIgcSJygpJwYUKygbFSwkGhwdFiotID/9oADAMBAQIRAxEAAAC1IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPkfUAAAAAAAAAAGMcYcydKdoZIAAAAIfNuaU7A1xyp2prCTAciQgYxkE3HYAAAAGGU NaZh1pzZ8DcmYWsBH5DB3htvEnrM69xnGdnxoPG/Lz5wcexsc69djYPRo8683ONlnXg494 PfTetPwZ5bxvkD3HGhIjOkZqVU/QJ/l0EW6LS3c/kqZV/YzNIp4SjXXtie5VDXSJ0XWbIufnX2myFv/WidpVFFGi1iKPb20n8npvO6mFd2d6LPhgNKe2aF1P0Cf5dBBcW8lHfWR9qn3ws FrhD6PaetU9yqH8 6rv5lkU/U 4ug879/wCtE7SqKKNFrEUe3tpP5PTed1MK7s70WfDAD5s/nxU/QJ/l0HnGYg0W/gvhZ8LXCH0e09ap7lUP591Xf2em8zt/WmOdNjsc65rk0se6bCHtFxaOby Jj3Tuv7C9FnwwA8M0drO3m2TSZmfHUe41dYnQ3OseNgSLfbHOuapNLR t7f44zl58S3IqYZjXInGTSQdGuxN0mkjDTaXHsOOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//2gAIAQIAAQUA 5nELQmAKAwD2cQtCcAriFriFoDANcQtcQtcQtCYAoDAPYIgFAcB7QUL3R7HNJn8omHxKTecEERMUQopBGm5BARrgmoqRvFztbbKcbrfeo 6nvdwexzXh/hJTwAm9Tra12UNdSNJriYzna22U43W 9R91Pe7zmm5QEDkEok3qdbWuyhrhJ0VMgC52tjAAectOB/1QHwN5y0YQEqe93eGanBRGm5RClk/MBEzeNOCiNNyiAUKZq4ZqBM3i4KIjwzVwzUco8PhmrhmpEogUiZvN9l//9oACAEDAAEFAPuZ0a1JoHPSiJyUACIi0VAE26hw6NaujWpRA5K6NaujWoWawUmgc9KInJ2ETMcTt1CBQAIiZoqAdwNtWOnrUFk0SCVZ1yrQ5TTTSXIpSrhNOrw4IoUmz/ooUq/QEtj3L5v1ZufeeRTbmPOT3A21Y64geZ z8x3XKqxbt93qJsGyJ08tREkrHuXzfqzc 88im3MecnuBtqx1eFTJqNnBViOuVVi3b7vUTYNwd0s7cqEse5ekjGN0ylWgogvdyCZHplKRTMVV5ye4G3rEas65CVeViHG3POCdw7SFOrMuQgXlYhzUV4j4dYjSjxHy2dchC9YjXWI03WIDzrEa6xGrisQy7p2kKX2X/9oACAEBAAEFAP7/ABEArq2viAgIf0r98kzQvkkRQT9xLB57FJEHCdvfpPEPpTDVRi6NXt/qAx 0x9HNV2Jb5eLDlmMXufmzrCy3thrAxE6dZBzRAIJbcb6hsdz65dkifkBzc7m6uj6rbcnVsex24EM4 jeUXi9owvKbTGIJJpxf5ZpzlK82msvskqskG1W2W4tZBJ4NFMwz3DMkYWrHWoGeSGJzjUR2S5sqszKICXGEUsd L0mA6dHgkWQs0jj97TcOEGyDfIsBcuLxMIpZXPubjqvc3HVWaVRq9nNkvHhTe5uOqSyRj5ZWeRbCbq5so7iaTxy/49hEhbT2K4xuTSNJYgXtVhj1kj9slMei18tMMUwdH3PZIGBgUk0JdouMNJqJoF26rtuMMgPYRKJPcGVyx5Bf3fUbCZbfpnfYrI7AaxQ UX9PTXEJRYLk/wDzgwzlEQsOIMlt75qw9f0n g1qZ M9M3yZU1/Tcb/IfYYpTFeRtM5rewdNG5d7VdtJaLge04kyaLOMwX93rVl6lpN9Kq4fnk1VS0hMZ6gZHLJrqw9f0n gVqZ M9MvyZU0/TsbfIfcc/jl3tV23TbYbZIItOYdc4hJIL 71qy9S0m lVcPz08OYFFOL49w1Hb7qw9f0wX2x2yx/wA1htaj3TZ1ivTpcbfb8ifzWG1JLvarnCsbfIfccAIoBjLIvjqVi0kvY6ZY3IbGyzVjNOaxuHY5nzaX1qZi0lvlw0zRyQWS3U9xpkQ7z2xyLVpxrkFO6al4pJ73e/bHIte2ORamEYkbjT37Y5Fr2xyLWF4vJLZjOA48njOdfZf/2gAIAQICBj8A8TKmJhZUxZUqYFSpUxZhZiYO2u2i8e4RgjEwHfZQoIeyxb9tF44sViHbQuEPZYt 2hplwrEPYvQh3lbajuFv2qCuHeeYsLFcO yhQoK5FCgkUKDFh4Mf/9oACAEDAgY/APEzRLtZwpyu k4k48xci9xl2l8YykvJGifazRPtZxJx5jRLtZon2s0S7Thi5cpxJx5rLorMy UZRW6y5F7jK7l259P3GX8fSRTqpr3EuWXtGpSUXm/RHC1I4mokcrUqiNSGlJUJbyO6zpZ1KyPNH5k SXt259P3GX1aiP8A1jWMo5 W/V0kuWXtsn8CO52I1S/Ic05Xr9yW8jus6WdSsjzR ZPkl7dufT9xCUaxzCmiXLL22S BHc7EU/oOMk8r/iS3kcqcsDTLtZc/pZclfxI0y7WRzJx4o/MnyS9u1rj3Inmajfl1dRHK1Kukx0S1f6JJSjpl6vKyWZqNNRHK1Kumxcce41w7kPjjT6iWaSjj6jXDuRrh3IlJtZceI1w7ka4dyINNNK73EkpRvyy9Xl4Mf//aAAgBAQEGPwD /wDmcad9Hq7WoZ/LjMbR2/7NvH2k7EXtnHnFzqhBCxO7j2ksR2EQdJsZbup0d/ux4OrPBqLZVCaJSN7HzFfgdG2rjeLsYbHTtH83PZ2atutVSOY6yS3RJJFE6nJ1LySRByndbvWvzsUvHgNZUWOrqhQoIqciZZ9LMVZJGjXJd2wLq7Jq6uKa1Cast0tW4ihnroFjh1sclVnSSTRqPdPpTvmxduBaOOqW9WWN5at5Y1WArG8aHQ4csdsyZZouOKrMYq3zvg lnrbqdymhoqYqH3Lbzpt0xp1BMQwy/iVFHKwU1VRTLuk Ft1JI Q ajYo6681xmNxQS2 logJ5p4iAd6gDKm6yOyR3VG7nH4TbZaigvBBaK33BFiklCglt0yPJG7Ko1FNe809LTpVuWollOVPSqS2XajBLfpzyxJXVJzkk6idiOPuUUdgAckddSnKWLrL2JE7qNh2VbFNPCc6erRSvxSAEf6H81XQ0T7utlp5Upnzy0yshCHPsZNljiTh9btQ8H/1FW4ZVFdeYNavSRhUen6SSdJHWYNCV6z6voVct3kp3W3cTU9JRJSU8VLCkIpJHyWOJY1y1OzdXHBP9Pv6gw2zhmiZaaa33GliLNPFLGEQLMXlGuXTulT93H5xp19xjjGq4sqRa6S5UrJSVUoYRHe bzRksAeiyROurq7zoY/rnxNaS1RZJ7HXpDWaWVWMzAx7GAI3iwyMurpaVxa DrTZbZDwlJVySrxBUyJvwyVLs/R1vImmQsmqODU8a6OqzauEZONg1Vwnb7PSUFouE8ZkiXzOk83EjIAwzjqtUrIupod9HN3uOAJOAtNxraGqgmvdxo0Ko8MU6SnU S69zAkut rpkWLV3HLeaeMHeyRzaAOfvv0gYBHMRmMXM3WJpBS7kxEO0enXr1Z6SO9GP53Qf9kP TFDBX3CntkYXKiWqqFj1LGQTpMhzfTqXPEslnuVNcUhIWZqWVJQhYZgNoJyzxJUVEixQQo0ksrkKqoozZmJ2AKBtxFT0/EVumnmdY4YkqoWZ3c5KqgNmWYnIYSmu93o7fUOgkSGpnjicoSVDAOQdOakY95rZ63D42Pea2etw NiVLPdaW4vAA0y0sySlA2YBbQTlnlgq3EtsDKciDVw5gj9bHvNbPW4fGwkUXEltklkYJGi1UJZmY5AABucnEdXxrR2dbnMuaT1rRwzSonR2sSjSBer0tWFsdvorTc H6CVZFoaURPTxTaSFbTF0RJpZul1mxRU17stJXwW5THQJNGG3KEKpWM86jJE5u9XENbxtQ26SCmyhgrLhoQpq2iMTMVbI97qxPwlw4bPLb6uOTzq00TwsJUYaZGkRCWfMbGZsR2uyUUVvt8RZo6WBdKKXYsxA FjniWn4moaWutkIM0grEVkj0DMyBm r0r3YK9HApeEqiyUdZXMsIWklgM8zMwCR6tRkfNuqmfW5RWRDZs3nNkDzZ8/Z LElZaYjPSSEu9Kn1kTHa2kd3H2dnSXF/WSN42Cwgq6lTzS9sDAxwp5Os/gYhucWqShk/c3KlB tgJ25A7NadeP53R6jPi8V9DMtRR1VqqpYJl6rI9OxB244e9p0f3hMUFVZrRVV9NHbo4nngjLqHE8zFSR2QGU/rYhW9W6e3tUBjAKhCmsJlq058 WoYmkstrqLgkBCzNTxlwpYEgHLt5Yvr3q11FvSeGBYWqIygYq7kgZ9rPFT5V/COM//O1W36HjYt1RNw9UrDDVQySMdGQVZASet2sWH0SX7QYv3pUP2Z5G9Op/28D0Go VOS/ezqv7B8cMe1aL7wnKVYAqdhB2gjGulfdnvGzI/wAjz4qxOQdadEg58wbt/HgfHjhTydZ/AxLdkhLUEMy080wIISSRSyBhzjUEbI/NxfOCrpLlSVlBWGzyuwCxzvC5aEk7Akx6Sf73lccPe06P7wnJw55Gp8OPHEXl6bwJOSp8q/hHCoLPb8lAA u7Gzv8W wVlto6emrN9vJYd7rG6heUZamYc6ZYsPosv2gxfvSofszyN6bT/tYHoNR8qcl 9nVf2D44Y9q0X3hPyZfoN8mB8eOFPJ1n8DHF9mucW9oa1qWOVeyNkpVlJzydGAdD3LLiqsleM2hOqnnAIWaFupIv0hz96 pO5xw97To/vCcnDnkanw48cReXpvAk5Knyr EcIWq4QxAJH4mDty B8Ut4tFdAlxpi4gLXBZBnKhjI0l lmrnFh9Fl 0GL2lyuNLRPJUxGNaiaOIsBGcyA7Lnj fW71uDx8CopZUnp5aynaOaJg6MOntVlzBGBUV9VDR04op1308ixJqJTIanIGeP59bvW4PHxxBJbq2CtjjoKtXenlSUK24Y5EoWyOOGPatF94T8mQAZkqwAHxYH/AMzc/VJvFxw1 D2uquHm8dUJ/NoXl0F9zp1aAdOelssX9Lzbam3NPJTGEVUTxawqy6tOsDPTmM8F6RAL9bQ0tvfYDIMs3p2Paky6GfVk09VdeLHUVHDtxigguFLJNK9LKqqiTKWZiVyCgDPPksL2a1VVxSCKoEzUsLyhCzJkG0A5Z5Yv0d5ttTbnmmp2hFVE8RcKrg6dYGeWfJO68M3Mq0jkHzSY7Cx7S492bn6pN4uKN5OGrkI1njZy1JMAFDgnPNcWWWz2mruMcNNKsr00LyhWMgIDFAcjj3Zufqk3i492bn6pN4uLFZ6e11Ut1hNNvqBIXadNOvUWjA1DLPtY92bn6pN4uPdm5 qTeLjjGiuFqqqStq0nFLTzQvHJKTSFQEVgC2bdHHD1XVcPXGCmguVJJPNJTSqiIk6FmZiuQVRtJ/wY/9k='
        }
        
        // Se a lista está vazia, retornar o distribuidor 291 padrão
        if (distributors.length === 0) {
          console.log('Lista vazia: retornando distribuidor 291 padrão')
          return [defaultDist291]
        }
        
        // Se tem 1 item mas não é o 291, retornar o distribuidor 291 padrão
        console.log('Lista com 1 item (não é 291): retornando distribuidor 291 padrão')
        return [defaultDist291]
      }
      
      return distributors
    },

    /**
     * Converte base64 em Blob URL para evitar problemas com data URIs longas ou inválidas.
     * Implementação baseada no repairBase64.js validado e funcional.
     */
    getDistributorImageUrl(distributor, key) {
      try {
        if (typeof window === 'undefined') return null
        if (!distributor || !distributor.img_base64) return null

        const raw = String(distributor.img_base64).trim()

        // Primeiro, reverte erros de transporte comuns
        let normalized = raw
        // '+' virando espaço em application/x-www-form-urlencoded
        normalized = normalized.replace(/%2B/gi, '+').replace(/ /g, '+')
        // '/' escapado como %2F
        normalized = normalized.replace(/%2F/gi, '/')

        // Sanitiza base64 usando a implementação validada
        const { mime, base64 } = this.sanitizeBase64Client(normalized)

        // Decodifica para Uint8Array
        let bytes
        try {
          bytes = this.decodeBase64ToUint8(base64)
        } catch (err) {
          // Tenta novamente após sanitização agressiva
          const stricter = base64.replace(/[^A-Za-z0-9+/=]/g, '')
          bytes = this.decodeBase64ToUint8(stricter)
        }

        // Se for jpeg, tenta recuperar por marcadores e garantir EOI
        if (mime.includes('jpeg') || mime.includes('jpg') || this.looksLikeJpeg(bytes)) {
          bytes = this.extractJpegFromUint8(bytes)
          bytes = this.ensureEOI(bytes)
        }

        // Detecta MIME real pelos bytes
        const detectedMime = this.detectMimeFromBytes(bytes)
        const finalMime = detectedMime || mime || 'image/jpeg'

        // Tenta criar Blob URL com bytes reparados
        try {
          const blob = new Blob([bytes], { type: finalMime })
          const url = (window.URL || window.webkitURL).createObjectURL(blob)
          return url
        } catch (err) {
          console.warn('Blob URL falhou:', err)
          // Fallback: constrói data URI manualmente
          let repairedBase64
          try {
            let bin = ''
            for (let i = 0; i < bytes.length; i++) {
              bin += String.fromCharCode(bytes[i])
            }
            repairedBase64 = btoa(bin)
          } catch (_) {
            repairedBase64 = base64
          }
          return `data:${finalMime};base64,${repairedBase64}`
        }
      } catch (e) {
        console.error('Falha ao criar URL da imagem do distribuidor:', e)
        return null
      }
    },

    // ====== Utilitários baseados no script repairBase64 (versão compatível com browser) ======
    sanitizeBase64Client(raw) {
      // Extrai cabeçalho data URI, se existir
      const m = String(raw).trim().match(/^data:([^;]+);base64,(.*)$/i)
      let mime = 'image/jpeg'
      let body = String(raw).trim()
      if (m) {
        mime = m[1]
        body = m[2]
      }
      // Normaliza base64 URL-safe
      body = body.replace(/-/g, '+').replace(/_/g, '/')
      // Remove inválidos (inclui espaços e quebras de linha)
      body = body.replace(/[^A-Za-z0-9+/=]/g, '')
      // Corrige padding
      const mod = body.length % 4
      if (mod === 1) {
        body = body.slice(0, -1)
      }
      while (body.length % 4 !== 0) body += '='
      return { mime, base64: body }
    },

    decodeBase64ToUint8(base64) {
      // Decodifica com atob para string binária e transforma em Uint8Array
      const bin = atob(base64)
      const bytes = new Uint8Array(bin.length)
      for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i)
      return bytes
    },

    findMarker(bytes, pattern) {
      for (let i = 0; i <= bytes.length - pattern.length; i++) {
        let ok = true
        for (let j = 0; j < pattern.length; j++) {
          if (bytes[i + j] !== pattern[j]) { ok = false; break }
        }
        if (ok) return i
      }
      return -1
    },

    findLastMarker(bytes, pattern) {
      for (let i = bytes.length - pattern.length; i >= 0; i--) {
        let ok = true
        for (let j = 0; j < pattern.length; j++) {
          if (bytes[i + j] !== pattern[j]) { ok = false; break }
        }
        if (ok) return i
      }
      return -1
    },

    extractJpegFromUint8(bytes) {
      // JPEG: começa com FFD8 e termina com FFD9
      const start = this.findMarker(bytes, new Uint8Array([0xFF, 0xD8]))
      const end = this.findLastMarker(bytes, new Uint8Array([0xFF, 0xD9]))
      if (start !== -1 && end !== -1 && end > start) {
        return bytes.subarray(start, end + 2)
      }
      // Se só achou início, recorta a partir do SOI e tenta completar depois
      if (start !== -1 && (end === -1 || end <= start)) {
        return bytes.subarray(start)
      }
      return bytes
    },

    looksLikeJpeg(bytes) {
      return bytes && bytes.length > 4 && bytes[0] === 0xFF && bytes[1] === 0xD8
    },

    hasEOI(bytes) {
      const end = this.findLastMarker(bytes, new Uint8Array([0xFF, 0xD9]))
      return end !== -1 && end >= 2
    },

    ensureEOI(bytes) {
      // Se já contém EOI, também corta qualquer lixo após ele
      const end = this.findLastMarker(bytes, new Uint8Array([0xFF, 0xD9]))
      if (end !== -1 && end + 2 <= bytes.length) {
        return bytes.subarray(0, end + 2)
      }
      // Se parece JPEG mas está sem EOI, acrescenta 0xFFD9
      if (this.looksLikeJpeg(bytes)) {
        const out = new Uint8Array(bytes.length + 2)
        out.set(bytes, 0)
        out[out.length - 2] = 0xFF
        out[out.length - 1] = 0xD9
        return out
      }
      return bytes
    },

    detectMimeFromBytes(bytes) {
      if (!bytes || bytes.length < 4) return null
      // JPEG
      if (bytes[0] === 0xFF && bytes[1] === 0xD8 && bytes[2] === 0xFF) return 'image/jpeg'
      // PNG
      if (bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4E && bytes[3] === 0x47) return 'image/png'
      // GIF
      if (bytes[0] === 0x47 && bytes[1] === 0x49 && bytes[2] === 0x46 && bytes[3] === 0x38) return 'image/gif'
      // WEBP: RIFF....WEBP
      if (bytes.length >= 12) {
        const riff = String.fromCharCode(bytes[0], bytes[1], bytes[2], bytes[3])
        const webp = String.fromCharCode(bytes[8], bytes[9], bytes[10], bytes[11])
        if (riff === 'RIFF' && webp === 'WEBP') return 'image/webp'
      }
      return null
    },

    repairBase64Client(input) {
      const { mime, base64 } = this.sanitizeBase64Client(input)
      let bytes
      try {
        bytes = this.decodeBase64ToUint8(base64)
      } catch (err) {
        // Tenta novamente com sanitização agressiva
        const stricter = base64.replace(/[^A-Za-z0-9+/=]/g, '')
        bytes = this.decodeBase64ToUint8(stricter)
      }
      // Se JPEG, tentar recuperar por marcadores
      if (mime.includes('jpeg') || mime.includes('jpg')) {
        bytes = this.extractJpegFromUint8(bytes)
      }
      // Remonta data URI
      // Converte bytes -> base64
      let repairedBase64
      try {
        // Usa btoa sobre string binária criada a partir dos bytes
        let bin = ''
        for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i])
        repairedBase64 = btoa(bin)
      } catch (_) {
        // Em caso de falha, retorna a base64 original já sanitizada
        repairedBase64 = base64
      }
      const dataUri = `data:${mime};base64,${repairedBase64}`
      return { mime, uint8: bytes, dataUri, base64: repairedBase64 }
    },

    base64ToBlob(decodedString, mimeType) {
      // Recebe string binária já decodificada (resultado de atob) e cria Blob
      const byteNumbers = new Array(decodedString.length)
      for (let i = 0; i < decodedString.length; i++) {
        byteNumbers[i] = decodedString.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      return new Blob([byteArray], { type: mimeType || 'image/jpeg' })
    },

    revokeObjectUrl(url) {
      try {
        if (typeof window === 'undefined') return
        const URL_ = window.URL || window.webkitURL
        URL_.revokeObjectURL(url)
      } catch (e) {
        // silencioso; caso não seja um object URL, nada a fazer
      }
    },

    onImageError(index) {
      // Marca a imagem com erro para usar o ícone padrão
      this.$set(this.imageError, index, true)
    },

    /**
     * Método chamado quando o estado é alterado
     */
    onStateChange() {
      console.log('Estado selecionado:', this.selectedState)
      
      // Se um estado foi selecionado, limpar o CEP e campos relacionados
      if (this.selectedState) {
        console.log('Limpando campos de CEP devido à seleção de estado')
        this.searchCep = ''
        this.proximity = 50
        
        // Buscar distribuidores automaticamente por estado
        this.searchDistributors()
      }
    },

    async searchDistributors() {
      // Mudança: aceitar 0 como um código válido
      if (!this.productCode && this.productCode !== 0 && this.productCode !== "0") return

      this.loading = true
      this.searchPerformed = true
      
      try {
        // Buscar dados do CEP e municípios próximos se CEP estiver preenchido
        let proximityMunicipios = []
        if (this.searchCep && this.searchCep.length >= 8) {
          proximityMunicipios = await this.getProximityMunicipios()
        }

        // Here you could implement filtering logic based on CEP, proximity, and state
        const response = await this.$api.products.getDistributors(this.productCode)
        console.log('Search API Response:', response)
        
        // Processar a resposta considerando a estrutura aninhada
        let distributors = []
        if (response.data && Array.isArray(response.data)) {
          distributors = response.data.map(item => {
            // Se tem distribuidor aninhado, usar ele, senão usar o item diretamente
            return item.distribuidor || item
          }).filter(distributor => {
            // Filtrar apenas distribuidores com status == true
            return distributor.status === true || distributor.status === 'true' || distributor.status === 1
          })
        }

        // Filter by proximity municipalities if CEP search was performed
        if (proximityMunicipios.length > 0) {
          console.log('=== FILTRO POR PROXIMIDADE PRECISO ===')
          console.log('Municípios próximos encontrados:', proximityMunicipios.map(m => m.nome))
          console.log('Distribuidores antes do filtro:', distributors.length)
          console.log('Cidades dos distribuidores:', distributors.map(d => d.cidade))
          
          // Primeiro filtro: distribuidores nas cidades próximas
          const distributorsInProximityMunicipios = distributors.filter(dist => {
            const distCidadeNorm = this.normalizeString(dist.cidade)
            const found = proximityMunicipios.some(municipio => {
              const municipioNomeNorm = this.normalizeString(municipio.nome)
              return distCidadeNorm === municipioNomeNorm
            })
            return found
          })
          
          console.log('Distribuidores nas cidades próximas:', distributorsInProximityMunicipios.length)
          
          // Segundo filtro: verificação precisa por distância real
          if (distributorsInProximityMunicipios.length > 0) {
            distributors = await this.filterByPreciseDistance(distributorsInProximityMunicipios)
          } else {
            distributors = []
          }
          
          console.log('Distribuidores após filtro por proximidade precisa:', distributors.length)
        }
        // Filter by state if selected and NO CEP proximity search was performed
        else if (this.selectedState && !this.searchCep.trim()) {
          console.log('=== FILTRO POR ESTADO ===')
          console.log('Estado selecionado:', this.selectedState)
          distributors = distributors.filter(dist => 
            dist.estado === this.selectedState || 
            dist.cidade === this.selectedState ||
            dist.endereco?.includes(this.selectedState)
          )
          console.log('Distribuidores após filtro por estado:', distributors.length)
        }

        // Aplicar regra do distribuidor 291
        distributors = this.applyDistributor291Rule(distributors)

        this.distributors = distributors
        console.log('Search distributors processed:', this.distributors.length, this.distributors)
      } catch (error) {
        console.error('Erro ao buscar distribuidores:', error)
        this.distributors = []
      } finally {
        this.loading = false
      }
    },

    /**
     * Busca dados do CEP na API ViaCEP com coordenadas geográficas
     */
    async getCepData(cep) {
      try {
        const cleanCep = cep.replace(/\D/g, '')
        if (cleanCep.length !== 8) {
          throw new Error('CEP deve ter 8 dígitos')
        }

        // Buscar dados básicos do CEP no ViaCEP
        const viaCepResponse = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`)
        const viaCepData = await viaCepResponse.json()
        
        if (viaCepData.erro) {
          throw new Error('CEP não encontrado')
        }

        console.log('ViaCEP Response:', viaCepData)

        // Buscar coordenadas usando dados pré-definidos da cidade
        const cityCoords = await this.getCityCoordinates(viaCepData.localidade, viaCepData.uf)
        if (cityCoords) {
          viaCepData.lat = cityCoords.lat
          viaCepData.lng = cityCoords.lng
          console.log(`Coordenadas encontradas para ${cleanCep} (${viaCepData.localidade}/${viaCepData.uf}): ${cityCoords.lat}, ${cityCoords.lng}`)
        } else {
          console.warn(`Coordenadas não encontradas para ${viaCepData.localidade}/${viaCepData.uf}`)
        }

        return viaCepData
      } catch (error) {
        console.error('Erro ao buscar CEP:', error)
        throw error
      }
    },

    /**
     * Busca coordenadas aproximadas de uma cidade usando dados pré-definidos
     */
    async getCityCoordinates(city, state) {
      // Coordenadas aproximadas de algumas cidades principais do Brasil
      const cityCoords = {
        'SP': {
          'São Paulo': { lat: -23.5505, lng: -46.6333 },
          'Campinas': { lat: -22.9099, lng: -47.0626 },
          'Santos': { lat: -23.9618, lng: -46.3322 },
          'Ribeirão Preto': { lat: -21.1775, lng: -47.8208 },
          'Sorocaba': { lat: -23.5015, lng: -47.4526 },
          'Orlândia': { lat: -20.7194, lng: -47.8869 },
          'Sales Oliveira': { lat: -20.7694, lng: -47.8369 },
          'Nuporanga': { lat: -20.7294, lng: -47.7469 }
        },
        'RJ': {
          'Rio de Janeiro': { lat: -22.9068, lng: -43.1729 },
          'Niterói': { lat: -22.8833, lng: -43.1036 }
        },
        'MG': {
          'Belo Horizonte': { lat: -19.9167, lng: -43.9345 },
          'Uberlândia': { lat: -18.9113, lng: -48.2622 }
        }
        // Adicione mais cidades conforme necessário
      }

      if (cityCoords[state] && cityCoords[state][city]) {
        return cityCoords[state][city]
      }

      return null
    },

    /**
     * Busca municípios próximos baseado no SIAFI e raio
     */
    async getProximityMunicipios() {
      try {
        if (!this.searchCep || this.searchCep.length < 8) {
          return []
        }

        // 1. Buscar dados do CEP na ViaCEP
        const cepData = await this.getCepData(this.searchCep)
        
        if (!cepData.siafi) {
          console.warn('SIAFI não encontrado para o CEP informado')
          return []
        }

        // 2. Buscar municípios próximos na API leadscapture
        const response = await fetch(
          `https://psdev-plugins.com.br/ceps/api.php?siafi=${cepData.siafi}&raio_km=${this.proximity}`
        )
        
        if (!response.ok) {
          throw new Error('Erro na API de proximidade')
        }

        const data = await response.json()
        console.log('Proximity API Response:', data)
        
        // A API retorna um objeto com a propriedade 'municipios'
        if (data.sucesso && data.municipios && Array.isArray(data.municipios)) {
          console.log('Municípios encontrados:', data.municipios.map(m => m.nome))
          return data.municipios
        }
        
        console.warn('Nenhum município encontrado na resposta da API')
        return []
      } catch (error) {
        console.error('Erro ao buscar municípios próximos:', error)
        return []
      }
    },

    /**
     * Normaliza string para comparação (remove acentos, converte para minúsculo)
     */
    normalizeString(str) {
      if (!str) return ''
      return str
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
    },

    /**
     * Filtra distribuidores por distância precisa usando coordenadas geográficas
     */
    async filterByPreciseDistance(distributors) {
      try {
        console.log('=== INICIANDO FILTRO POR DISTÂNCIA PRECISA ===')
        
        // Buscar coordenadas do CEP de origem
        const originCepData = await this.getCepData(this.searchCep)
        if (!originCepData.lat || !originCepData.lng) {
          console.warn('Coordenadas do CEP de origem não encontradas')
          return distributors // Retorna todos se não conseguir obter coordenadas
        }
        
        const originLat = parseFloat(originCepData.lat)
        const originLng = parseFloat(originCepData.lng)
        console.log(`CEP origem: ${this.searchCep} - Lat: ${originLat}, Lng: ${originLng}`)
        
        const filteredDistributors = []
        
        for (const distributor of distributors) {
          try {
            console.log(`Verificando distribuidor: ${distributor.razao_social} - CEP: ${distributor.cep}`)
            
            // Buscar coordenadas do CEP do distribuidor
            const distCepData = await this.getCepData(distributor.cep)
            
            if (distCepData.lat && distCepData.lng) {
              const distLat = parseFloat(distCepData.lat)
              const distLng = parseFloat(distCepData.lng)
              
              // Calcular distância real entre os pontos
              const distance = this.calculateDistance(originLat, originLng, distLat, distLng)
              console.log(`  - Coordenadas: Lat: ${distLat}, Lng: ${distLng}`)
              console.log(`  - Distância calculada: ${distance.toFixed(2)}km`)
              console.log(`  - Raio máximo: ${this.proximity}km`)
              
              if (distance <= this.proximity) {
                console.log(`  - ✅ INCLUÍDO (dentro do raio)`)
                filteredDistributors.push({
                  ...distributor,
                  _distance: distance // Adiciona distância para referência
                })
              } else {
                console.log(`  - ❌ EXCLUÍDO (fora do raio)`)
              }
            } else {
              console.log(`  - ⚠️ Coordenadas não encontradas, incluindo por segurança`)
              filteredDistributors.push(distributor)
            }
          } catch (error) {
            console.error(`Erro ao processar distribuidor ${distributor.razao_social}:`, error)
            // Em caso de erro, inclui o distribuidor para não perder dados
            filteredDistributors.push(distributor)
          }
        }
        
        console.log(`=== FILTRO CONCLUÍDO: ${filteredDistributors.length}/${distributors.length} distribuidores ===`)
        return filteredDistributors
        
      } catch (error) {
        console.error('Erro no filtro por distância precisa:', error)
        return distributors // Retorna todos em caso de erro
      }
    },

    /**
     * Calcula a distância entre duas coordenadas usando a fórmula de Haversine
     * @param {number} lat1 - Latitude do ponto 1
     * @param {number} lng1 - Longitude do ponto 1
     * @param {number} lat2 - Latitude do ponto 2
     * @param {number} lng2 - Longitude do ponto 2
     * @returns {number} Distância em quilômetros
     */
    calculateDistance(lat1, lng1, lat2, lng2) {
      const R = 6371 // Raio da Terra em km
      const dLat = this.toRadians(lat2 - lat1)
      const dLng = this.toRadians(lng2 - lng1)
      
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(this.toRadians(lat1)) * Math.cos(this.toRadians(lat2)) *
                Math.sin(dLng / 2) * Math.sin(dLng / 2)
      
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      const distance = R * c
      
      return distance
    },

    /**
     * Converte graus para radianos
     */
    toRadians(degrees) {
      return degrees * (Math.PI / 180)
    }

  }
}
